<template>
    <tw-modal
        ref="modal"
    >
        <template v-slot:content>
                <div class="w-full px-4 pt-5 pb-4 bg-white sm:p-6 sm:pb-4">
                    <div class="w-full sm:flex sm:items-start">
                        <div class="flex items-center justify-center flex-shrink-0 w-12 h-12 mx-auto bg-blue-100 rounded-full sm:mx-0 sm:h-10 sm:w-10">
                            <!-- Heroicon name: outline/exclamation -->
                            <svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M7 8h10M7 12h4m1 8l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-3l-4 4z" />
                            </svg>
                        </div>
                        <div class="w-full mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                            <h3 class="text-lg font-medium leading-6 text-gray-900" id="modal-title">
                                {{ modalTitle }}
                            </h3>
                            <div class="mt-2">
                                <ul>
                                    <li
                                        class="text-sm text-red-600"
                                        :class="{'hidden': !errorMessages.length}"
                                        v-for="(error, index) in errorMessages"
                                        :key=index
                                    >
                                        {{ error }}
                                    </li>
                                </ul>
                                <div class="mt-4">
                                    <label for="note" class="block text-sm text-gray-500">Note</label>
                                    <div class="mt-1">
                                        <textarea v-model="form.note" rows="4" name="note" id="note" class="block w-full border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm"></textarea>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="flex justify-end px-4 py-3 space-x-2 sm:space-x-4 bg-gray-50 sm:px-6">
                    <a
                        class="tw-button-gray"
                        @click="closeModal"
                    >{{ trans('app.cancel').titleCase() }}</a>
                    <input
                        type="button"
                        class="tw-button-green"
                        :value="trans('app.save').titleCase()"
                        :disabled="isEmpty"
                        @click="submit"
                    >
                </div>
        </template>
    </tw-modal>
</template>

<script>
import Trumbowyg from 'vue-trumbowyg';
import 'trumbowyg/dist/ui/trumbowyg.css';
import Form from 'form-backend-validation';

export default {
    components: {
        Trumbowyg,
    },

    props: {
        type: {
            type: String,
            required: true,
        },
        projectId: {
            type: Number,
            required: false,
        },
        typeId: {
            type: Number,
            required: true,
        },
    },

    data () {
        return {
            note: null,
            projects: [],
            form: new Form({
                noteable_id: null,
                noteable_type: null,
                note: '',
            }),
            errorMessages: {},
        };
    },

    computed: {
        isEdit () {
            return ! _.isNull(this.note);
        },

        isEmpty () {
            return _.isEmpty(this.form.note);
        },

        modalTitle () {
            let lang_key = this.isEdit ? 'app.edit_this' : 'app.add_new_this';

            return this.trans(lang_key, {this: this.transChoice('app.note', 1)}).titleCase();
        },

        actionRoute () {
            return this.isEdit
                ? this.route('notes.update', {note: this.note.id})
                : this.route('notes.store');
        },

        groupedProjects () {
            let projects = this.projects;

            if (! _.isUndefined(this.projectId)) {
                projects = _.filter(projects, project => project.id === this.projectId);
            }

            return _.chain(projects)
                .sortBy(project => project.name)
                .groupBy(project => project.name)
                .value();
        },
    },

    listeners: {
        'open-note-add-modal' () {
            this.form.noteable_id = this.typeId;
            this.form.noteable_type = this.type;

            this.showModal();
        },
    },

    methods: {
        showModal () {
            this.$refs.modal.show();
        },

        closeModal () {
            this.$refs.modal.hide();
            this.form.reset();
            this.note = null;
        },

        async fetchProjects () {
            try {
                this.projects = [];

                let { data } = await axios.get(this.route('projects.list'));

                this.projects = data.projects;
            } catch (errors) {
                console.error(errors);
            }
        },

        async submit () {
            try {
                // @TODO: Not ready for EDIT... as we don't use.
                await this.form.post(this.actionRoute);

                this.closeModal();

                OSPEvent.$emit('notes-updated', {});
            } catch (errors) {
                console.error(errors);
            }
        },

        setNoteForEdit (note) {
            this.note = _.clone(note);
            this.form.noteable_id = note.noteable_id;
            this.form.noteable_type = note.noteable_type;
            this.form.project_id = note.project_id;
            this.form.note = note.note;
        },
    },

    async mounted () {
        await this.fetchProjects();
    },
};
</script>

<style>
.trumbowyg-box.trumbowyg-editor-visible {
  min-height: 150px !important;
}

.trumbowyg-editor {
  min-height: 150px !important;
}
</style>
